import React from 'react'
import { connect } from 'react-redux'
import { BrowserRouter, Route, Switch } from 'react-router-dom'

import $ from 'jquery'

import { processSilentRenew } from 'redux-oidc';
import { SecureRoute } from './Authorization';
import { setBaseUrl } from './GlobalStateContainer/actions';

import Header from './Header/Header'

import SigninCallbackPage from './Authorization/SigninCallback';

import ProductBricksList from './Pages/ProductBricks/ProductBricksList'
import ProductSeriesList from './Pages/ProductSeries/ProductSeriesList'
import TemplatesList from './Pages/Templates/TemplatesLists'
import UnprocessedRecordsList from './Pages/UnprocessedRecords/UnprocessedRecordsList'
import ReportingList from './Pages/Reporting/ReportingList'
import AdvancedSearchList from './Pages/AdvancedSearch/AdvancedSearchList'
import ProductViewMain from './Pages/ProductView/ProductView'

import UsersList from './Pages/Users/UsersList'
import BidsList from './Pages/BidTracker/BidsList'
import QuotesList from './Pages/Quotes/QuotesList'
import SurveysList from './Pages/Surveys/SurveysList'
import HolidaysList from './Pages/Holidays/HolidaysList'
import LocationsList from './Pages/Locations/LocationsList'
import LocationMenuGroupsList from './Pages/LocationMenuGroups/LocationMenuGroupsList'

import RankingReportsList from './Pages/RankingReports/RankingReports'
import InactiveReportList from './Pages/InactiveReport/InactiveReportList'

import ScopesList from './Pages/Scopes/ScopesList'
import SowsList from './Pages/Sows/SowList'

import JobsList from './Pages/Jobs/JobsList'

import LocationsMngtList from './Pages/LocationMngt/LocationsList'

import BidsMngtList from './Pages/BidTrackerAdmin/BidTrackerList'

import MyAccount from './Pages/Account/MyAccount'
import LoginPage from './Authorization/LoginPage';
import StartPage from './Pages/Start/StartPage';

const ProductBricks = () => <ProductBricksList />
const ProductSeries = () => <ProductSeriesList />
const Templates = () => <TemplatesList />
const UnprocessedRecords = () => <UnprocessedRecordsList />
const Reporting = () => <ReportingList />
const AdvancedSearch = () => <AdvancedSearchList />
const ProductView = () => <ProductViewMain />

const Users = () => <UsersList />
const Bids = () => <BidsList />
const Quotes = () => <QuotesList />
const Surveys = () => <SurveysList />
const Holidays = () => <HolidaysList />
const Locations = () => <LocationsList />
const LocationMenuGroups = () => <LocationMenuGroupsList />

const RankingReports = () => <RankingReportsList />
const InactiveReport = () => <InactiveReportList />

const Scopes = () => <ScopesList />
const Sows = () => <SowsList />

const Jobs = () => <JobsList />

const LocationMngt = () => <LocationsMngtList />

const BidMngt = () => <BidsMngtList />

const Account = () => <MyAccount />

const LoginCallback = (props) => <SigninCallbackPage {...props} />

const Login = () => <LoginPage />

var menuExpanded = "false";

const restrictedMenuItems = [
    { name: "IT", role: 3 },
    { name: "Inventory", role: 4 },
    { name: "Quote Requests", role: 5 },
];

class ProductManageReactApp extends React.Component {
    constructor(props) {
        super(props);
        
        setBaseUrl(props.initialData.ReicoBridgeApiUrl);

        this.state = {
            filteredMenu: this.getFilteredMenuItems()
        }
    }

    placeContent() {
        let navbar_width = parseInt($('#sidebar').css('width'))

        $('#content').css('margin-left', (Math.max(0, navbar_width - 40)).toString() + 'px')
        $('div.editpages').css('margin-left', (Math.max(0, navbar_width - 40)).toString() + 'px')
    }

    setViewHdrSize() {
        if ($('tr.view.tabs').length) {
            let view_width = 0

            $('tr.view.tabs').each(function () {
                if (parseInt($(this).css('width')) > view_width)
                    view_width = parseInt($(this).css('width'))
            })

            let viewcore_width = ((view_width / 2.02) - 11).toFixed(0) + '%'

            $('div.viewcore_hdr').css('width', viewcore_width)
        }
    }

    renderMenu() {
        menuExpanded = localStorage.getItem("MenuExpanded")
        if (menuExpanded == null)
            menuExpanded = "false"

        if (menuExpanded === "true") {
            $('nav#sidebar').addClass('active')
            $('button.sidebarCollapse').addClass('fa-rotate-180')

            var submenuExpanded = localStorage.getItem("SubMenuExpanded")

            if (submenuExpanded == null)
                submenuExpanded = {}
            else
                submenuExpanded = JSON.parse(submenuExpanded)

            for (let [key, value] of Object.entries(submenuExpanded)) {
                if (value) {
                    $('a[data-target="' + key + '"]').removeClass('collapsed')
                    $('a[data-target="' + key + '"] i.fa-angle-left').addClass('fa-rotate-270')

                    $("ul" + key).addClass('in')
                    $("ul" + key).css('height', 'auto')
                }
            }
        }

        setInterval(this.placeContent, 75)

        setInterval(this.setViewHdrSize, 350)

        $('button.sidebarCollapse').click(function () {
            if ($(this).hasClass('fa-rotate-180')) {
                menuExpanded = "false"
                localStorage.removeItem("SubMenuExpanded")
            }
            else
                menuExpanded = "true"

            localStorage.setItem("MenuExpanded", menuExpanded)
        })

        $('a.dropdown-toggle').click(function () {
            var submenuExpanded = localStorage.getItem("SubMenuExpanded")

            if (submenuExpanded == null)
                submenuExpanded = {}
            else
                submenuExpanded = JSON.parse(submenuExpanded)

            submenuExpanded[$(this).attr('data-target')] = !submenuExpanded[$(this).attr('data-target')]
            localStorage.setItem("SubMenuExpanded", JSON.stringify(submenuExpanded))
        })
    }

    componentDidMount() {
        this.renderMenu();
    }

    userHasAccessToMenuItem(itemName, userRoles) {
        let restrictedItem = restrictedMenuItems.find((m) => m.name == itemName);
        if (!!restrictedItem) {
            return userRoles.includes(restrictedItem.role);
        }
        else return true;
    }

    getFilteredMenuItems = () => {
        let filteredMenuItems = JSON.parse(JSON.stringify(this.props.initialData.MenuItems));
        let roleIds = [];

        if (!!this.props.roles) {
            this.props.roles.forEach((r) => {
                if (r["assigned"]) {
                    roleIds.push(r["roleId"])
                }
            })
        }

        for (let i = filteredMenuItems.length; i > 0; i--) {
            if (!this.userHasAccessToMenuItem(filteredMenuItems[i - 1].Title, roleIds)) {
                filteredMenuItems.splice(i - 1, 1);
            } else {
                if (!!filteredMenuItems[i - 1].Children) {
                    for (let ci = filteredMenuItems[i - 1].Children.length; ci > 0; ci--) {
                        if (!this.userHasAccessToMenuItem(filteredMenuItems[i - 1].Children[ci - 1].Title, roleIds)) {
                            filteredMenuItems[i - 1].Children.splice(ci - 1, 1);
                        } else {
                            if (!!filteredMenuItems[i - 1].Children[ci - 1].Children) {
                                for (let cci = filteredMenuItems[i - 1].Children[ci - 1].Children.length; cci > 0; cci--) {
                                    if (!this.userHasAccessToMenuItem(filteredMenuItems[i - 1].Children[ci - 1].Children[cci - 1].Title, roleIds)) {
                                        filteredMenuItems[i - 1].Children[ci - 1].Children.splice(cci - 1, 1);
                                        // Max depth is 2; consider making recursive if that changes
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        return filteredMenuItems;
    }

    render() {

        return (
            <BrowserRouter basename={this.props.initialData.basename}>
                <Header
                    menuItems={this.state.filteredMenu}
                    alertMessage={this.props.initialData.AlertMessage}
                    dispatch={this.props.dispatch}
                    logoLink={this.props.initialData.LogoLink}
                />

                <section id="content">
                    <div>
                        <div className="productManagement">
                            <Switch>
                                <Route path="/Callback" component={LoginCallback} />
                                <Route path="/Silent_Renew" render={processSilentRenew} />
                                <Route path="/Login" component={LoginPage} />

                                <SecureRoute path="/ProductBricksList" component={ProductBricks} menu={this.state.filteredMenu} />
                                <SecureRoute path="/ProductSeriesList" component={ProductSeries} menu={this.state.filteredMenu} />
                                <SecureRoute path="/ProductTemplatesList" component={Templates} menu={this.state.filteredMenu} />
                                <SecureRoute path="/UnprocessedRecordsList" component={UnprocessedRecords} menu={this.state.filteredMenu} />
                                <SecureRoute path="/ReportingList" component={Reporting} menu={this.state.filteredMenu} />
                                <SecureRoute path="/AdvancedSearchList" component={AdvancedSearch} menu={this.state.filteredMenu} />
                                <SecureRoute path="/ProductViewMain" component={ProductView} menu={this.state.filteredMenu} />

                                <SecureRoute path="/UsersList" component={Users} menu={this.state.filteredMenu} />
                                <SecureRoute path="/BidsList" component={Bids} menu={this.state.filteredMenu} />
                                <SecureRoute path="/QuotesList" component={Quotes} menu={this.state.filteredMenu} />
                                <SecureRoute path="/SurveysList" component={Surveys} menu={this.state.filteredMenu} />
                                <SecureRoute path="/HolidaysList" component={Holidays} menu={this.state.filteredMenu} />
                                <SecureRoute path="/LocationsList" component={Locations} menu={this.state.filteredMenu} />
                                <SecureRoute path="/LocationMenuGroupsList" component={LocationMenuGroups} menu={this.state.filteredMenu} />

                                <SecureRoute path="/RankingReportsList" component={RankingReports} menu={this.state.filteredMenu} />
                                <SecureRoute path="/InactiveReportList" component={InactiveReport} menu={this.state.filteredMenu} />

                                <SecureRoute path="/ScopesList" component={Scopes} menu={this.state.filteredMenu} />
                                <SecureRoute path="/SowsList" component={Sows} menu={this.state.filteredMenu} />

                                <SecureRoute path="/JobsList" component={Jobs} menu={this.state.filteredMenu} />

                                <SecureRoute path="/LocationsMngt" component={LocationMngt} menu={this.state.filteredMenu} />

                                <SecureRoute path="/BidsMngt" component={BidMngt} menu={this.state.filteredMenu} />

                                <SecureRoute path="/MyAccount" component={Account} menu={this.state.filteredMenu} />

                                <Route path="/" component={() => (<StartPage mainContent={this.props.initialData.StartPageContent} />)} />
                            </Switch>
                        </div>
                    </div>
                </section>
            </BrowserRouter>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    user: state.oidc.user,
    roles: state.userManager.roles,
    isActive: state.userManager.isActive
});

export default connect(mapStateToProps)(ProductManageReactApp)
